import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LandingPage from "../pages/landing/page";
import PrivacyPage from "../pages/legal-pages/PrivacyPage";
import TermsPage from "../pages/legal-pages/TermsPage";
import PolicyPage from "../pages/legal-pages/PolicyPage";
import FaqPage from "../pages/legal-pages/FaqPage";
import CareersPage from "../pages/legal-pages/CareersPage";
import GuidePage from "../pages/guide/page";
import Dashboard from "../pages/dashboard/page";
import Inbox from "../pages/inbox/page";
import Approval from "../pages/approval/page";
import ArHub from "../pages/arHub/page";
import Marketing from "../pages/marketing/page";
import Finance from "../pages/finance/page";
import Legal from "../pages/legal/page";
import Admin from "../pages/admin/page";
import ModeSelect from "../pages/modeSelect/page";
import RoleSelect from "../pages/roleSelect/page";
import CompanySelect from "../pages/companySelect/page";
import LoginPage from "../pages/auth/LoginPage";
import ConcertHub from "../pages/concert-hub/page";
import FoundationHub from "../pages/foundation-hub/page";
import IpHub from "../pages/ip-hub/page";
import CampaignHub from "../pages/campaign-hub/page";
import EtiquettePage from "../pages/etiquette/page";
import JoinPage from "../pages/join/page";
import ProfilePage from "../pages/profile/page";
import ProjectBoardPage from "../pages/project-board/page";
import PortfolioPage from "../pages/portfolio/page";

const routes: RouteObject[] = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/mode-select", element: <ModeSelect /> },
  { path: "/company-select", element: <CompanySelect /> },
  { path: "/role-select", element: <RoleSelect /> },
  { path: "/admin", element: <Admin /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/inbox", element: <Inbox /> },
  { path: "/approval", element: <Approval /> },
  { path: "/ar-hub", element: <ArHub /> },
  { path: "/marketing", element: <Marketing /> },
  { path: "/finance", element: <Finance /> },
  { path: "/legal", element: <Legal /> },
  { path: "/concert-hub", element: <ConcertHub /> },
  { path: "/foundation-hub", element: <FoundationHub /> },
  { path: "/ip-hub", element: <IpHub /> },
  { path: "/campaign-hub", element: <CampaignHub /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/policy", element: <PolicyPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/guide", element: <GuidePage /> },
  { path: "/careers", element: <CareersPage /> },
  { path: "/etiquette", element: <EtiquettePage /> },
  { path: "/join", element: <JoinPage /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/project-board", element: <ProjectBoardPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
